import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
import _ from 'lodash';
import { DONT_SHOW_REDUX_ERROR } from '../../common/Constants';

const StyledReduxFormError = props => {
  if (!_.isEmpty(props.error) && props.error !== DONT_SHOW_REDUX_ERROR) {
    return (
      <Message negative>
        <Message.Header>Error</Message.Header>
        <p>{props.error}</p>
      </Message>
    );
    } 
  return (<span />);
};

StyledReduxFormError.propTypes = {
  error: PropTypes.string,
};

export { StyledReduxFormError };



// WEBPACK FOOTER //
// ./src/components/messages/StyledReduxFormError.js